import React, { useState } from 'react';
import { COLORS } from '../../../../utils/constants';
import { adminAPI } from '../../../../services/api';
import { useAdminToast } from '../../../../hooks/useAdminToast';

const CreateIDOTransactionModal = ({ clientId, projects, onClose, onSuccess }) => {
  const { toast } = useAdminToast();
  const [form, setForm] = useState({
    ido_id: '',
    type: 'add', // 'add' or 'subtract'
    token_amount: '',
  });
  const [loading, setLoading] = useState(false);

  const selectedProject = projects.find(p => p.id === form.ido_id);
  const price = selectedProject?.sell_price || selectedProject?.buy_price || 0;
  const tokenAmount = parseFloat(form.token_amount) || 0;
  const usdtValue = tokenAmount * price;

  const handleSubmit = async () => {
    if (!form.ido_id || !form.token_amount) {
      toast.validation('Выберите проект и введите количество');
      return;
    }
    if (tokenAmount <= 0) {
      toast.validation('Введите корректное количество');
      return;
    }
    setLoading(true);
    try {
      await adminAPI.createClientIDOTransaction(clientId, {
        ido_id: form.ido_id,
        type: form.type === 'add' ? 'buy' : 'sell',
        usdt_amount: usdtValue,
        token_amount: tokenAmount,
        price: price,
      });
      onSuccess();
    } catch (err) {
      toast.apiError(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      position: 'fixed',
      inset: 0,
      backgroundColor: 'rgba(0,0,0,0.7)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 1100,
    }} onClick={onClose}>
      <div style={{
        backgroundColor: COLORS.card,
        borderRadius: '12px',
        width: '100%',
        maxWidth: '360px',
        padding: '20px',
      }} onClick={e => e.stopPropagation()}>
        <h3 style={{ color: COLORS.text, fontSize: '16px', fontWeight: '700', margin: '0 0 16px' }}>
          Изменить баланс IDO
        </h3>

        {/* Project Selection */}
        <div style={{ marginBottom: '12px' }}>
          <label style={{ display: 'block', color: COLORS.textSecondary, fontSize: '12px', marginBottom: '4px' }}>
            Токен IDO
          </label>
          <select
            value={form.ido_id}
            onChange={(e) => setForm({ ...form, ido_id: e.target.value })}
            style={{
              width: '100%',
              padding: '10px',
              backgroundColor: COLORS.background,
              border: `1px solid ${COLORS.border}`,
              borderRadius: '6px',
              color: COLORS.text,
              fontSize: '14px',
            }}
          >
            <option value="">Выберите токен</option>
            {projects.map(p => (
              <option key={p.id} value={p.id}>{p.name} (${p.symbol}) - ${p.buy_price}</option>
            ))}
          </select>
        </div>

        {/* Type Selection */}
        <div style={{ marginBottom: '12px' }}>
          <label style={{ display: 'block', color: COLORS.textSecondary, fontSize: '12px', marginBottom: '4px' }}>
            Операция
          </label>
          <div style={{ display: 'flex', gap: '8px' }}>
            <button
              onClick={() => setForm({ ...form, type: 'add' })}
              style={{
                flex: 1,
                padding: '10px',
                backgroundColor: form.type === 'add' ? COLORS.success : COLORS.background,
                border: `1px solid ${form.type === 'add' ? COLORS.success : COLORS.border}`,
                borderRadius: '6px',
                color: form.type === 'add' ? '#fff' : COLORS.textSecondary,
                fontWeight: '600',
                cursor: 'pointer',
              }}
            >
              + Начислить
            </button>
            <button
              onClick={() => setForm({ ...form, type: 'subtract' })}
              style={{
                flex: 1,
                padding: '10px',
                backgroundColor: form.type === 'subtract' ? COLORS.danger : COLORS.background,
                border: `1px solid ${form.type === 'subtract' ? COLORS.danger : COLORS.border}`,
                borderRadius: '6px',
                color: form.type === 'subtract' ? '#fff' : COLORS.textSecondary,
                fontWeight: '600',
                cursor: 'pointer',
              }}
            >
              − Списать
            </button>
          </div>
        </div>

        {/* Amount */}
        <div style={{ marginBottom: '16px' }}>
          <label style={{ display: 'block', color: COLORS.textSecondary, fontSize: '12px', marginBottom: '4px' }}>
            Количество токенов
          </label>
          <input
            type="number"
            value={form.token_amount}
            onChange={(e) => setForm({ ...form, token_amount: e.target.value })}
            placeholder="0"
            style={{
              width: '100%',
              padding: '12px',
              backgroundColor: COLORS.background,
              border: `1px solid ${COLORS.border}`,
              borderRadius: '6px',
              color: COLORS.text,
              fontSize: '18px',
              fontWeight: '600',
              boxSizing: 'border-box',
            }}
          />
          {selectedProject && tokenAmount > 0 && (
            <div style={{ color: COLORS.textSecondary, fontSize: '12px', marginTop: '6px' }}>
              ≈ ${usdtValue.toFixed(2)} USDT (по ${price})
            </div>
          )}
        </div>

        {/* Buttons */}
        <div style={{ display: 'flex', gap: '10px' }}>
          <button
            onClick={onClose}
            style={{
              flex: 1,
              padding: '12px',
              backgroundColor: COLORS.background,
              border: `1px solid ${COLORS.border}`,
              borderRadius: '8px',
              color: COLORS.textSecondary,
              fontWeight: '600',
              cursor: 'pointer',
            }}
          >
            Отмена
          </button>
          <button
            onClick={handleSubmit}
            disabled={loading || !form.ido_id || tokenAmount <= 0}
            style={{
              flex: 1,
              padding: '12px',
              backgroundColor: form.type === 'add' ? COLORS.success : COLORS.danger,
              border: 'none',
              borderRadius: '8px',
              color: '#fff',
              fontWeight: '600',
              cursor: loading ? 'not-allowed' : 'pointer',
              opacity: (!form.ido_id || tokenAmount <= 0) ? 0.5 : 1,
            }}
          >
            {loading ? '...' : (form.type === 'add' ? 'Начислить' : 'Списать')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CreateIDOTransactionModal;
